import { ModifiedWebSocket } from "../utils/websocketModifier.util";
import { FunctionResolverFunction, IResolverStatic, Resolver } from "../types";

export abstract class ModelResolver extends Resolver {
    // Сериализация API-объекта туда-обратно (включая функции как id).
    options: {
        session: ModifiedWebSocket;
    };

    constructor(options: { session: ModifiedWebSocket }) {
        super();
        this.options = { session: options.session };
    }

    public abstract serialize(
        model: any,
        getFunctionId: (executor: Function) => Promise<string>
    ): Promise<object> | object;

    public abstract deserialize(
        model: any,
        getFunctionWrapper: (id: string) => Promise<FunctionResolverFunction>
    ): Promise<any> | any;
}

export interface IModelResolver extends IResolverStatic {
    new (options: { session: ModifiedWebSocket }): ModelResolver;
}
